import React, { useEffect } from 'react';

import { setup } from '../../../config/server/server.config';

export const Spaceloop: React.FC = () => {
  useEffect(() => {
    document.location.assign(setup.SPACELOOP_FE);
  });
  return <></>;
};
